import { Anchor } from '@klv/atoms/anchor';

import Typography from '@klv/atoms/typography';
import styled from 'styled-components';

export const ArticleCount = styled(Typography)``;

export const Name = styled(Typography)``;

export const Description = styled(Typography)``;

export const StyledSubcategoryCard = styled(Anchor)`
  background: ${({ theme }) => theme.subcategoryCard.default.background};
  outline: 0 solid ${({ theme }) => theme.subcategoryCard.default.border};
  border-radius: 14px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
  color: ${({ theme }) => theme.subcategoryCard.default.color};
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  max-width: 27rem;
  padding: 2.8rem 2.4rem;
  text-align: center;
  text-decoration: none;
  width: 100%;
  transition: outline 0.2s ease-in-out;

  &:hover {
    box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.11);
    background: ${({ theme }) => theme.subcategoryCard.hover.background};
    outline: 3px solid ${({ theme }) => theme.subcategoryCard.hover.border};
    color: ${({ theme }) => theme.subcategoryCard.hover.color};
  }

  &:active {
    box-shadow: 0px 13px 37px 0px rgba(0, 0, 0, 0.21);
    background: ${({ theme }) => theme.subcategoryCard.hover.background};
    outline: 3px solid ${({ theme }) => theme.subcategoryCard.hover.border};
    color: ${({ theme }) => theme.subcategoryCard.hover.color};
  }

  ${ArticleCount},
  ${Name} {
    color: inherit;
  }
`;
